// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2CQPZ","addWidgetButton":"Header_addWidgetButton__cZjd7","dashboardTabs":"Header_dashboardTabs__3vFv-","active":"Header_active__3e-GW"};